"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _UIButton = _interopRequireDefault(require("./UIButton"));

var _UILoadingSpinner = _interopRequireDefault(require("../loading/UILoadingSpinner"));

var _Functions = require("../core/Functions");

var _ButtonConstants = require("../button/ButtonConstants");

var getClassName = function getClassName(className, use, displayResult, isLoading) {
  return (0, _classNames.default)('private-loading-button', className, _ButtonConstants.USE_CLASSES[use], {
    'loading private-loading-button--loading': isLoading || displayResult
  });
};

var _default = _react.default.createClass({
  displayName: "UILoadingButton",
  propTypes: (0, _extends2.default)({}, _UIButton.default.propTypes, {
    failed: _UILoadingSpinner.default.propTypes.failed,
    size: _UILoadingSpinner.default.propTypes.size,
    use: _UILoadingSpinner.default.propTypes.use,
    duration: _react.PropTypes.number,
    loading: _react.PropTypes.bool,
    resultIcon: _UILoadingSpinner.default.propTypes.resultIcon,
    onLoadingFinish: _react.PropTypes.func,
    spinnerProps: _react.PropTypes.object,
    preventClicksOnLoading: _react.PropTypes.bool,
    keepResultAfterFinish: _react.PropTypes.bool
  }),
  getDefaultProps: function getDefaultProps() {
    var _UILoadingSpinner$def = _UILoadingSpinner.default.defaultProps,
        failed = _UILoadingSpinner$def.failed,
        resultIcon = _UILoadingSpinner$def.resultIcon;
    return (0, _extends2.default)({}, _UIButton.default.defaultProps, {
      failed: failed,
      onLoadingFinish: _emptyFunction.default,
      preventClicksOnLoading: true,
      keepResultAfterFinish: false,
      resultIcon: resultIcon,
      size: 'medium',
      use: 'secondary'
    });
  },
  getInitialState: function getInitialState() {
    var loading = this.props.loading;
    return {
      displayResult: false,
      isLoading: loading || false
    };
  },
  componentWillMount: function componentWillMount() {
    var _this$props = this.props,
        loading = _this$props.loading,
        duration = _this$props.duration;
    (0, _invariant.default)(typeof loading !== 'undefined' || duration, 'You must supply either a duration or loading prop to `LoadingButton`');
  },
  componentDidMount: function componentDidMount() {
    var duration = this.props.duration;
    var isLoading = this.state.isLoading;

    if (duration && isLoading) {
      this.loadingTimeout = setTimeout(this.handleLoadingFinish, duration);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var wasLoading = this.props.loading;
    var failed = nextProps.failed,
        loading = nextProps.loading,
        resultIcon = nextProps.resultIcon;
    var hasResult = resultIcon && !failed;
    var shouldDisplayResult = hasResult && wasLoading && !loading;

    if (loading !== wasLoading) {
      this.setState({
        isLoading: loading,
        displayResult: shouldDisplayResult
      });
    }
  },
  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
    var duration = nextProps.duration;
    var wasLoading = this.state.isLoading;
    var isLoading = nextState.isLoading;
    var startedLoading = !wasLoading && isLoading;

    if (duration && startedLoading) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = setTimeout(this.handleLoadingFinish, duration);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this.loadingTimeout);
  },
  handleLoadingFinish: function handleLoadingFinish() {
    var _this$props2 = this.props,
        failed = _this$props2.failed,
        resultIcon = _this$props2.resultIcon;
    var hasResult = resultIcon && !failed;
    this.setState({
      isLoading: false,
      displayResult: hasResult
    });

    if (!hasResult) {
      this.setDisplayResult();
    }
  },
  setDisplayResult: function setDisplayResult() {
    var _this$props3 = this.props,
        onLoadingFinish = _this$props3.onLoadingFinish,
        keepResultAfterFinish = _this$props3.keepResultAfterFinish;
    this.setState({
      displayResult: keepResultAfterFinish
    });
    onLoadingFinish();
  },
  handleClick: function handleClick(evt) {
    var _this$props4 = this.props,
        duration = _this$props4.duration,
        onClick = _this$props4.onClick,
        preventClicksOnLoading = _this$props4.preventClicksOnLoading;
    var _this$state = this.state,
        displayResult = _this$state.displayResult,
        isLoading = _this$state.isLoading;

    if (preventClicksOnLoading && (isLoading || displayResult)) {
      return;
    }

    (0, _Functions.callIfPossible)(onClick, evt);

    if (evt.defaultPrevented) {
      return;
    }

    if (!isLoading && duration) {
      this.setState({
        isLoading: true
      });
    }
  },
  render: function render() {
    var _this$props5 = this.props,
        children = _this$props5.children,
        className = _this$props5.className,
        disabled = _this$props5.disabled,
        __duration = _this$props5.duration,
        failed = _this$props5.failed,
        __loading = _this$props5.loading,
        __onClick = _this$props5.onClick,
        __onLoadingFinish = _this$props5.onLoadingFinish,
        __preventClicksOnLoading = _this$props5.preventClicksOnLoading,
        __keepResultAfterFinish = _this$props5.keepResultAfterFinish,
        resultIcon = _this$props5.resultIcon,
        size = _this$props5.size,
        spinnerProps = _this$props5.spinnerProps,
        use = _this$props5.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props5, ["children", "className", "disabled", "duration", "failed", "loading", "onClick", "onLoadingFinish", "preventClicksOnLoading", "keepResultAfterFinish", "resultIcon", "size", "spinnerProps", "use"]);
    var _this$state2 = this.state,
        isLoading = _this$state2.isLoading,
        displayResult = _this$state2.displayResult;
    var disabledUnlessLoading = disabled && !isLoading && !displayResult;
    return _react.default.createElement(_UIButton.default, (0, _extends2.default)({}, rest, {
      size: size,
      use: use,
      "data-loading": isLoading,
      disabled: disabledUnlessLoading,
      className: getClassName(className, use, displayResult, isLoading),
      onClick: this.handleClick
    }), _react.default.createElement("div", {
      className: "private-loading-button__content private-button--internal-spacing"
    }, children), _react.default.createElement(_UILoadingSpinner.default, (0, _extends2.default)({}, spinnerProps, {
      className: "private-loading-button__spinner",
      "data-loading": null,
      failed: failed,
      use: use,
      size: size,
      resultIcon: resultIcon,
      showResult: displayResult,
      onResultDisplayFinish: this.setDisplayResult
    })));
  }
});

exports.default = _default;
module.exports = exports.default;